<template>
  <div>
    <roles-menu></roles-menu>

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn block color="accent" to="/settings/role/mapping/new">{{ $t("settings.role.mapNewRole") }}</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="mappings" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">
            {{ props.item.authItems.toString() }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn :to="'/settings/role/mapping/edit/' + props.item.name" icon v-on="on">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn :disabled="$store.getters['Ajax/loading']" @click="remove(props.item)" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import RolesMenu from "../../../../components/Settings/RolesMenu.vue";

export default {
  name: "SettingsRoleMappingView",
  components: { RolesMenu },
  data: () => ({
    search: "",
    mappings: []
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("settings.role.wnbRole"), value: "name" },
        {
          text: this.$t("settings.role.permissionsAndRoles"),
          value: "auth_items"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  created() {
    this.axios.get("settings/role-mapping/list").then(resp => {
      this.mappings = resp.data;
    });
  },
  methods: {
    remove(item) {
      let confirm = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.role.removeMappingDialog.content"),
        title: this.$t("settings.role.removeMappingDialog.title")
      });
      confirm.then(() => {
        this.axios.post("settings/role-mapping/delete-mapping", { name: item.name }).then(() => {
          this.axios.get("settings/role-mapping/list").then(resp => {
            this.mappings = resp.data;
            this.$store.dispatch("snackbarPush", {
              text: this.$t("settings.role.removeMappingDialog.removed"),
              color: "error",
              position: "down"
            });
          });
        });
      });
    }
  }
};
</script>

<style scoped></style>
